import { IntegrationService } from '../../../../../../services/exports/Constants';

export default {
  title: 'Integraatiot',
  services: {
    [IntegrationService.Tabless]: 'Tabless',
    [IntegrationService.WinOrder]: 'WinOrder',
    [IntegrationService.ExpertOrder]: 'ExpertOrder',
    [IntegrationService.Deliverect]: 'Deliverect',
    [IntegrationService.Liefersoft]: 'Liefersoft',
    [IntegrationService.Hubrise]: 'HubRise',
  },
  labels: {
    no_integrations: '{{company}}:lla ei ole määritettyjä integraatioita.',
  },
  buttons: {
    add_integration: 'Lisää integraatio',
  },
  toasts: {
    error: 'Muutosten tallennus epäonnistui',
    success: 'Muutokset tallennettu',
    load_error: 'Integraatioiden lataaminen epäonnistui',
  },
};
